import { InputRule, SizeRule } from './image'


export enum ScreenshotSize {
    IOS_SIX_DOT_FIVE = 'sixDotFive',
    IOS_FIVE_DOT_FIVE = 'fiveDotFive',
    IOS_TWELVE_DOT_NINE = 'twelveDotNine',
}

export function getSizeRulesFor(screenshotSize: ScreenshotSize): SizeRule[] {
    switch (screenshotSize) {
        case ScreenshotSize.IOS_SIX_DOT_FIVE:
            return [
                { width: 1284, height: 2778 },
                { width: 2778, height: 1284 },
                { width: 1242, height: 2688 },
                { width: 2688, height: 1242 },
            ]
        case ScreenshotSize.IOS_FIVE_DOT_FIVE:
            return [
                { width: 1242, height: 2208 },
                { width: 2208, height: 1242 },
            ]
        case ScreenshotSize.IOS_TWELVE_DOT_NINE:
            return [
                { width: 2048, height: 2732 },
                { width: 2732, height: 2048 },
            ]
    }
}

export function getInputRuleFor(screenshotSize: ScreenshotSize): InputRule {
    switch (screenshotSize) {
        case ScreenshotSize.IOS_SIX_DOT_FIVE:
        case ScreenshotSize.IOS_FIVE_DOT_FIVE:
        case ScreenshotSize.IOS_TWELVE_DOT_NINE:
            return { maximumNumber: 10, minimumNumber: 3 }
    }
}
